<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <DrawDeliveryDetail :drawDeliveryModel="drawDeliveryModel"></DrawDeliveryDetail>
                <div class="bg-white w-full rounded-xl">
                    <div class="text-center text-22 text-a-gray-666666 pt-36 pb-20 px-6">
                        <span v-if="isPrivilegeMessage"
                            v-html="privilegeMessage"></span>
                        <span v-if="isDelivery"
                            v-html="deliveryMessage"></span>
                    </div>
                    <div class=" flex justify-center w-full pt-2 pb-11 ">
                        <img class=" w-20" src="../../../../assets/logo/Logo_bzb_new.svg" alt=""/>
                    </div>
                </div>
                <div class="flex absolute bottom-0 left-0 w-full">
                    <img class="w-10 h-10 m-auto" @click="clickOk()" src="@/assets/icon/ic-close.svg" alt=""/>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import { CampaignType } from "@/helper/StaticValue.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import DrawDeliveryDetail from '@/module/Detail/modal/DrawDeliveryModal/component/DrawDeliveryDetail.vue';

export default {
    name: "DrawDeliveryModal",
    mixins: [LocaleMixin],
    components: {
        DrawDeliveryDetail
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,

            drawDeliveryModel: null,

            deliveryMessage: '',
            isDelivery: false,

            privilegeMessage: '',
            isPrivilegeMessage: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function(config) {
            this.drawDeliveryModel = config.drawDeliveryModel;
            console.log(this.drawDeliveryModel)
            this.initial();

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackClose();
        },

        initial: function () {
            if(this.drawDeliveryModel.privilegeMessage) {
                this.isPrivilegeMessage = true;
                this.privilegeMessage= this.drawDeliveryModel.privilegeMessage;
            } else {
                if(this.drawDeliveryModel.delivered) {
                    this.isDelivery = true;
                    this.deliveryMessage = this.lbl.serial.delivery;
                }

                if(this.drawDeliveryModel.type == CampaignType.Draw) {
                    this.isPrivilegeMessage = true;
                    this.privilegeMessage = this.getDrawMessage();
                }
            }
        },

        getDrawMessage: function () {
            let date = DatetimeHelper.getDatetimeFullFormat( this.drawDeliveryModel.campaignExpiredTimestamp);
            return Util.stringFormat(this.lbl.serial.draw, date);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import "@/style/base/image.scss";
    .modal {
        @extend %modal;
         .modal-content {
            width: 100%;
            padding: 16px;
            padding-bottom: 20px;
        }
    }
    .campaign-image {
        div {
            @include boxRatio(66.66%);
        }
    }
</style>
